import React, { Component } from "react";
import axios from "axios";
import Header from "./header";
import MenuBar from "./navbar";
import SocialMediaLinks from "./socialmedialinks";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  ResponsiveContainer,
  PieChart,
  Pie,
  Cell,
} from "recharts";
import { Navigate } from "react-router-dom";
import { BASE_URL, isTokenValid } from "./utility";
import { Card, Container, Spinner } from "react-bootstrap";

const COLORS = [
  "#00C49F",
  "#0088FE",
  "#FF8042",
  "#FFBB28",
  "#AA00FF",
  "#FF4444",
];

class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      redirectToLogin: false,
      taxDelhi: [],
      proDelhi: [],
      proOdisha: [],
      taxOdisha: [],
      creditDelhi: [],
      creditOdisha: [],
    };
  }

  componentDidMount() {
    this.fetchAllData();
  }

  // Fetch with auto 401 handling
  safeGet = async (url, headers) => {
    try {
      const res = await axios.get(url, { headers });
      return res.data;
    } catch (err) {
      if (err.response && err.response.status === 401) {
        localStorage.removeItem("token");
        this.setState({ redirectToLogin: true });
      }
      return null;
    }
  };

  fetchAllData = async () => {
    const token = localStorage.getItem("token");
    const headers = { Authorization: token };

    const taxDelhi = await this.safeGet(`${BASE_URL}/getInvoiceDetails/tax/delhi`, headers);
    const proDelhi = await this.safeGet(`${BASE_URL}/getInvoiceDetails/pro/delhi`, headers);
    const proOdisha = await this.safeGet(`${BASE_URL}/getInvoiceDetails/pro/odisha`, headers);
    const taxOdisha = await this.safeGet(`${BASE_URL}/getInvoiceDetails/tax/odisha`, headers);
    const creditDelhi = await this.safeGet(`${BASE_URL}/getInvoiceDetails/credit/delhi`, headers);
    const creditOdisha = await this.safeGet(`${BASE_URL}/getInvoiceDetails/credit/odisha`, headers);

    this.setState({
      taxDelhi: taxDelhi || [],
      proDelhi: proDelhi || [],
      proOdisha: proOdisha || [],
      taxOdisha: taxOdisha || [],
      creditDelhi: creditDelhi || [],
      creditOdisha: creditOdisha || [],
      loading: false,
    });
  };

  render() {
    if (this.state.redirectToLogin) return <Navigate to="/auth" replace />;
    if (!isTokenValid()) return <Navigate to="/auth" replace />;

    const {
      taxDelhi,
      proDelhi,
      proOdisha,
      taxOdisha,
      creditDelhi,
      creditOdisha,
      loading,
    } = this.state;

    const combinedData = [
      { name: "Delhi – Tax", value: taxDelhi.length },
      { name: "Delhi – Proforma", value: proDelhi.length },
      { name: "Odisha – Tax", value: taxOdisha.length },
      { name: "Odisha – Proforma", value: proOdisha.length },
      { name: "Delhi – Credit", value: creditDelhi.length },
      { name: "Odisha – Credit", value: creditOdisha.length },
    ];

    return (
      <div style={{ backgroundImage: `url(${BASE_URL}download/general/bg)` }}>
        <Header />
        <MenuBar />

        <Container style={{ marginTop: "2rem", minHeight: "60vh" }}>
          <h2 style={{ color: "white" }}>Business Dashboard</h2>

          {/* ⭐ ONLY CONTENT LOADING SPINNER ⭐ */}
          {loading ? (
            <div
              style={{
                height: "300px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Spinner animation="border" variant="light" style={{ width: "60px", height: "60px" }} />
            </div>
          ) : (
            <>
              {/* ---------- Bar Chart ---------- */}
              <Card
                className="mb-4 shadow-sm"
                style={{
                  borderRadius: "15px",
                  backgroundColor: "rgba(255,255,255,0.95)",
                }}
              >
                <Card.Body>
                  <h4 style={{ color: "#007bff" }}>Invoice Count</h4>
                  <hr />
                  <ResponsiveContainer width="100%" height={300}>
                    <BarChart data={combinedData}>
                      <XAxis dataKey="name" />
                      <YAxis />
                      <Tooltip />
                      <Legend />
                      <Bar dataKey="value">
                        {combinedData.map((entry, i) => (
                          <Cell key={i} fill={COLORS[i % COLORS.length]} />
                        ))}
                      </Bar>
                    </BarChart>
                  </ResponsiveContainer>
                </Card.Body>
              </Card>

              {/* ---------- Pie Chart ---------- */}
              <Card
                className="mb-4 shadow-sm"
                style={{
                  borderRadius: "15px",
                  backgroundColor: "rgba(255,255,255,0.95)",
                }}
              >
                <Card.Body>
                  <h4 style={{ color: "#007bff" }}>Distribution</h4>
                  <hr />
                  <ResponsiveContainer width="100%" height={300}>
                    <PieChart>
                      <Pie
                        data={combinedData}
                        cx="50%"
                        cy="50%"
                        outerRadius={100}
                        dataKey="value"
                      >
                        {combinedData.map((entry, i) => (
                          <Cell key={i} fill={COLORS[i % COLORS.length]} />
                        ))}
                      </Pie>
                      <Tooltip />
                    </PieChart>
                  </ResponsiveContainer>
                </Card.Body>
              </Card>
            </>
          )}
        </Container>

        <SocialMediaLinks />
        <div style={{ height: "2rem" }} />
      </div>
    );
  }
}

export default Dashboard;
